/**
 * 订单模块接口
 * @description 下单、退票、异常订单、车票等订单相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/** 普通车票消位 */
export const Http_postCommonTicketToOpen = async (
  params: Request.postCommonTicketToOpenParams
) => {
  return await axios.post(Api.POST_COMMON_TICKET_TO_OPEN, params);
};

/** 普通车票消位预检查 */
export const Http_postCommonTicketToOpenPre = async (
  params: Request.postCommonTicketToOpenParams
) => {
  return await axios.post(Api.POST_COMMON_TICKET_TO_OPEN_PRE, params);
};

/**
 * 获取打印收据url地址
 * @returns 获取打印收据
 */
export const Http_getReceipt = async (
  /** 订单ID */
  id: number
) => {
  return await axios.get<ResponseData.Receipt>(Api.GET_RECEIPT, {
    params: {
      id,
    },
  });
};

/**
 * 补价票下单
 */
export const Http_postPremiumTicketOrder = async (params: {
  /** 是否常规售卖补价票，0-否，1-是，默认是 */
  isNormalTakeOrder?: 0 | 1;
  takeTicketReqs: {
    /** 绑定的车票ID */
    ticketId: number;
    /** 补价票金额（目前只有通融改签或者取位补差价才会有值，其他的都是直接查ticket表对应的补价金额） */
    premiumTicketAmount?: number;
  }[];
}) => {
  return await axios.post<any>(Api.POST_PREMIUM_TICKET_ORDER, params);
};

/**
 * 行李票后台退票预校验
 */
export const Http_postBaggageRefundPreVerify = async (
  baggageTicketNo: string
) => {
  return await axios.post<ResponseData.BaggageRefundVerify>(
    Api.POST_BAGGAGE_REFUND_PRE_VERIFY,
    {
      baggageTicketNo,
    }
  );
};

/**
 * 行李票后台退票确认
 */
export const Http_postBaggageRefundConfirm = async (
  params: Request.BaggageRefundConfirmParams
) => {
  return await axios.post<ResponseData.BaggageRefundConfirm>(
    Api.POST_BAGGAGE_REFUND_CONFIRM,
    params
  );
};

/*
 * 包车票后台退票确认
 */
export const Http_postRefundConfirm = async (
  params: Request.RefundConfirmParams
) => {
  return await axios.post<ResponseData.RefundConfirmItem>(
    Api.POST_REFUND_CONFIRM,
    params
  );
};

/**
 * 获取Open票价格规则（包含标准价和营销价）
 * @param params 查询参数
 * @returns 价格规则列表
 */
export const Http_getOpenPriceWithMarket = async (
  params: Request.GetOpenPriceWithMarketParams
) => {
  return await axios.get<ResponseData.OpenPriceRuleOption[]>(
    Api.GET_OPEN_PRICE_WITH_MARKET,
    {
      params,
    }
  );
};

/**
 * Open票下单
 * @param params 下单参数
 * @returns 订单信息
 */
export const Http_postOpenOrderTake = async (
  params: Request.PostOpenOrderTakeParams
) => {
  return await axios.post<ResponseData.OpenOrderTakeData>(
    Api.POST_OPEN_ORDER_TAKE,
    params
  );
};

/**
 * 该函数用于通过 HTTP POST 请求向服务器发送座位详细信息。
 */
export const Http_postSeatDetail = async (
  params: Request.postSeatDetailParams
) => {
  return await axios.post<ResponseData.ResponseSeatDetail>(
    Api.POST_SEAT_DETAIL,
    params
  );
};

/**
 * 获取班次票价列表
 * @param params 查询参数
 * @returns 班次票价列表
 */
export const Http_getLinePricesForDisplay = async (
  params: Request.GetLinePricesForDisplayParams
) => {
  return await axios.get<ResponseData.GetLinePricesForDisplayData>(
    Api.GET_LINE_PRICES_FOR_DISPLAY,
    {
      params,
    }
  );
};

/** 返程座位改为Open票 */
export const Http_postFacadeSaleLineSeatChangeToOpen = async (params: {
  /** 返程锁座id */
  backLockSeatId: number;
  /** 去程购物车详情id */
  goDetailId: number;
  /** 返程购物车详情id */
  backDetailId: number;
}) => {
  return await axios.post<any>(Api.POST_CHANGE_TO_OPEN, params);
};
